module.exports = __webpack_public_path__ + "img/dataservice_flyzjg.a11b25d8.png";